import { render, staticRenderFns } from "./confirm-info.vue?vue&type=template&id=3bbe12f4&scoped=true"
import script from "./confirm-info.vue?vue&type=script&lang=js"
export * from "./confirm-info.vue?vue&type=script&lang=js"
import style0 from "./confirm-info.vue?vue&type=style&index=0&id=3bbe12f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbe12f4",
  null
  
)

export default component.exports